import { render, staticRenderFns } from "./crearBodega.vue?vue&type=template&id=575a525f"
import script from "./crearBodega.vue?vue&type=script&lang=js"
export * from "./crearBodega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports